// assets
import {
    IconDiscountCheck,
    IconUserCheck,
    IconSettings,
    IconCheck,
    IconFilePencil,
    IconUpload,
    IconClock,
    IconDeviceMobile,
    IconBrandWhatsapp
} from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconSettings,
    IconCheck,
    IconUpload,
    IconClock,
    IconDeviceMobile,
    IconFilePencil,
    IconDiscountCheck,
    IconBrandWhatsapp
};

// ==============================|| MAIN MENU ITEMS ||============================== //

const adminmenu = {
    id: 'adminmenu',
    title: 'Admin',
    type: 'group',
    roles: ['Admin'],
    children: [
        {
            id: 'adminmenu-Approval',
            title: 'Exemption Approval',
            type: 'item',
            url: '/approval',
            icon: icons.IconDiscountCheck,
            breadcrumbs: true,
            roles: ['Admin']
        },
        // {
        //     id: 'adminmenu-Adjustment',
        //     title: 'Fee Correction',
        //     type: 'item',
        //     url: '/adjustment',
        //     icon: icons.IconFilePencil,
        //     breadcrumbs: false,
        //     roles: ['Admin']
        // },
        {
            id: 'adminmenu-Configuration',
            title: 'Configuration',
            type: 'item',
            url: '/commonconfig',
            icon: icons.IconSettings,
            breadcrumbs: true,
            roles: ['Admin', 'ConfigurationUser']
        },
        {
            id: 'adminmenu-WhatsApp',
            title: 'WhatsApp Marketing',
            type: 'item',
            url: '/whatsappmessaging',
            icon: icons.IconBrandWhatsapp,
            breadcrumbs: true,
            roles: ['Admin', 'SuperUser']
        }
    ]
};

export default adminmenu;
